import { createContext } from "react";
import { SubmitCampaign } from "types/Campaign";

interface CustomProps {
  submitCampaign: SubmitCampaign;
  setSubmitCampaign: Function;
  managingStep: string;
  setManagingStep: Function;
  saveAsDraft: Function;
}

export const CampaignContext = createContext({} as CustomProps);
